export const NOT_ACTIVE_TIMEOUT_KEY = 'ACTIVE-SESSION';
export const NOT_ACTIVE_TIMEOUT = 3600; // 3600 = 1h
export const ACTIVE_CHECK_TIME_STEP = 300;
export const INTERVAL_CHECKING_TIME = 300000; // 60000 = 1 minute
